import React from 'react';
import { MenuItem } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export const GoToEditActionMenuItem = ({ businessProfile }) => {
  const navigate = useNavigate();

  const onClickingDetails = () => {
    navigate('/business-profiles/:id/edit'.replace(':id', businessProfile.profile_id));
  };
  return (
    <>
      <MenuItem id="edit" key="edit" onClick={onClickingDetails}>
        Edit
      </MenuItem>
    </>
  );
};
